import { useLocaleFormatter } from '@casops/shared/hooks/useLocaleFormatter';
import { EmptyCell } from '@casops/components/tables/formatters/genericFormatters';

export interface DurationRendererProps {
  value: number | null;
}

export function DurationRenderer({ value }: DurationRendererProps): string {
  const { showDurationFromSeconds } = useLocaleFormatter();

  return typeof value === 'number' ? showDurationFromSeconds(value) : EmptyCell;
}

export default DurationRenderer;
